import { createComponent } from '@lit/react'
import * as React from 'react'

import Component from '../../components/card/card-image.component.js'

const tagName = 'dap-ds-card-image'

/**
 * `dap-ds-card-image`
 * @summary A card image is a container for images in a card.
 * @element dap-ds-card-image
 * @title - Card image
 * @group card
 *
 * @slot - The default slot for the image. The slot can accept any element, for example a video. If nothing is added to the slot, the image will be rendered.
 *
 * @csspart base - The main card image container.
 *
 * @cssproperty --dds-card-image-width - The width of the image. Default is `100%`.
 * @cssproperty --dds-card-image-height - The height of the image. Default is `auto`.
 * @cssproperty --dds-card-image-object-fit - How the image fits within its container. Default is `cover`.
 * @cssproperty --dds-card-image-background-position - The background position of the image. Default is `center`.
 * @cssproperty --dds-card-image-background-size - How the background image is sized. Default is `cover`.
 * @cssproperty --dds-card-image-background-repeat - How the background image repeats. Default is `no-repeat`.
 */
const reactWrapper = createComponent({
  tagName,
  elementClass: Component,
  react: React,
  events: {},
  displayName: 'DapDSCardImage',
})

export default reactWrapper
